import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-table-2 text-base" />
              </span>
              <span className="font-heading font-bold text-foreground-950 text-lg">USFansSheet</span>
            </Link>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 text-sm">
              {t('footer.categories')}
            </h4>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 hover:text-primary-700 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  {t(`categoryNames.${cat.id}`)}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 text-sm">
              {t('footer.resources')}
            </h4>
            <div className="mt-4 flex flex-col gap-2">
              <Link to="/" className="text-foreground-600 hover:text-primary-700 text-sm whitespace-nowrap cursor-pointer transition-colors">
                {t('footer.home')}
              </Link>
              <Link to="/article/usfans-spreadsheet-guide" className="text-foreground-600 hover:text-primary-700 text-sm whitespace-nowrap cursor-pointer transition-colors">
                {t('footer.guide')}
              </Link>
              <a href="#categories" className="text-foreground-600 hover:text-primary-700 text-sm whitespace-nowrap cursor-pointer transition-colors">
                {t('footer.categories')}
              </a>
            </div>
          </div>
        </div>

        <p className="mt-10 pt-6 border-t border-background-200 text-xs text-foreground-500 leading-relaxed">
          {t('footer.disclaimer')}
        </p>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} USFansSheet.link. {t('footer.rights')}
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-600 hover:text-primary-700 cursor-pointer transition-colors"
          >
            {t('footer.backToTop')}
            <i className="ri-arrow-up-line" />
          </button>
        </div>
      </div>
    </footer>
  );
}